import AxiosAPI from '../../../utils/AxiosAPI';
// --Subscriptions Feature Deleted
export const handleDeleteSubscriptionsFeaturesOpe = (featureId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions-feature/${featureId}`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// --Subscriptions Feature Updated
export const handleEditSubscriptionsFeaturesOpe = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions-feature/${id}`)
            .put({ ...formData, id })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// --Subscriptions Feature Added
export const handleAddSubscriptionsFeaturesOpe = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions-feature`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// --Subscriptions Feature List
export const handleGetSubscriptionsDetailsOpe = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// --Get Github Repo List
export const handleGetGithubRepoListOpe = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/github/repositories`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// --Link-up with Github Repo with Subscriptions
export const handleLinkGithubRepoWithAppOpe = (subscriptionId, fullName) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`api/subscriptions/${subscriptionId}/github/add`)
            .put({ subscriptionId, GithubFullName: fullName })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// --Unlink Github Repo with Subscriptions
export const handleUnlinkGithubRepoWithAppOpe = (subscriptionId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`api/subscriptions/${subscriptionId}/github/remove`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Github Releases List
export const handleGetGithubReleasesListOpe = (subscriptionId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${subscriptionId}/github/releases`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// subscription renew
export const handleRenewSubscription = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/renew`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// change basic info
export const ApiSubsEditBasicInfo = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/change-basic-info`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Get Package Pricing
export const handleGetPackagePricingApi = (subscriptionId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/get-pricing-for-renew/${subscriptionId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// -- edit Subscription Details
export const handleEditProductOpe = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Modify Version info
export const handleModifyVersionInfoOpe = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/change-version-info`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title || '');
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Change Product Logo
export const handleChangeProductLogoOpe = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/change-logo`)
            .put(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Share License key
export const handleSendLicenseInfoOpe = (id, emailData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/license/share-code`)
            .post({
                subscriptionId: id || 0,
                emails: emailData || []
            })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const ApiChangeSubsStartDate = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/change-start-date`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
